'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_Category(id_$_lo, id_$_hi, name, isMain, accountId) {
  this.Bg = 0;
  this.Bh = 0;
  this.hk = null;
  this.lk = false;
  this.Ln = null;
  this.Bg = id_$_lo;
  this.Bh = id_$_hi;
  this.hk = name;
  this.lk = isMain;
  this.Ln = accountId;
}
export { $c_Lmealorama_Category as $c_Lmealorama_Category };
$p = $c_Lmealorama_Category.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_Category;
/** @constructor */
function $h_Lmealorama_Category() {
}
export { $h_Lmealorama_Category as $h_Lmealorama_Category };
$h_Lmealorama_Category.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, 115155230);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.Bg, this.Bh)));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.hk));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.lk ? 1231 : 1237));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.Ln));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 4);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_Category)) {
    if ((this.lk === x$0.lk)) {
      var x_$_lo = this.Bg;
      var x_$_hi = this.Bh;
      var $x_2 = x$0;
      var x$1_$_lo = $x_2.Bg;
      var x$1_$_hi = $x_2.Bh;
      var $x_1 = (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
    } else {
      var $x_1 = false;
    }
    if (($x_1 && (this.hk === x$0.hk))) {
      var x$2 = this.Ln;
      var x$2$1 = x$0.Ln;
      return ((x$2 === null) ? (x$2$1 === null) : x$2.f(x$2$1));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 4;
});
$p.r = (function() {
  return "Category";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.Bg, this.Bh);
      break;
    }
    case 1: {
      return this.hk;
      break;
    }
    case 2: {
      return this.lk;
      break;
    }
    case 3: {
      return this.Ln;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_Category(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jo)));
}
export { $isArrayOf_Lmealorama_Category as $isArrayOf_Lmealorama_Category };
var $d_Lmealorama_Category = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_Category, "mealorama.Category", ({
  jo: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_Category as $d_Lmealorama_Category };
//# sourceMappingURL=mealorama.-Category.js.map
